import { Box, BoxProps } from '@mantine/core'

// import { useHandlerUrls } from 'hooks/useHandlerUrls'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'

type Props = {
  banner?: {
    desktop: string
    mobile: string
  }
  url?: string
  alt?: string
} & BoxProps
export const AppFooterBanner = ({
  banner,
  url = '',
  alt = '',
  className,
  classNames,
  styles,
  ...rest
}: Props) => {
  // const linkData = useHandlerUrls([url])
  const isMobile = useIsMobile()
  // const { isExternalUrl } = linkData?.[0] || {}
  const { classes, cx } = useStyles(undefined, {
    name: 'AppFooterBanner',
    styles,
    classNames,
  })
  return (
    <Box
      className={cx(className, classes.root)}
      component={isMobile && url ? 'a' : 'div'}
      href={url}
      target={'_blank'}
      // target={isExternalUrl ? '_blank' : '_self'}
      {...rest}
    >
      <img
        loading="lazy"
        src={isMobile ? banner?.mobile : banner?.desktop}
        alt={alt}
      />
    </Box>
  )
}
